import { authorizedApiClient } from "./config";

export type MeetingPrepRun = {
  id: string;
  workspace_id: string;
  meeting_external_id: string;
  status: "pending" | "running" | "success" | "failed" | string;
  action_type: string;
  created_at: string;
  completed_at?: string | null;
  workflow_run_id?: string | null;
  error_message?: string | null;
  request_payload?: Record<string, any> | null;
  response_payload?: Record<string, any> | null;
};

type TriggerMeetingPrepParams = {
  workspace_id: string;
  meeting_external_id: string;
  meeting_title?: string | null;
  scheduled_at?: string | null;
  company_name?: string | null;
  company_domain?: string | null;
  attendees?: string[];
  force?: boolean;
};

export const triggerMeetingPrep = async ({
  workspace_id,
  meeting_external_id,
  meeting_title,
  scheduled_at,
  company_name,
  company_domain,
  attendees = [],
  force = false,
}: TriggerMeetingPrepParams) =>
  authorizedApiClient.post<MeetingPrepRun>(
    `/workspace/${workspace_id}/meetings/${meeting_external_id}/prep`,
    {
      meeting_title: meeting_title || undefined,
      scheduled_at: scheduled_at || undefined,
      company_name: company_name || undefined,
      company_domain: company_domain || undefined,
      attendees,
      force,
    },
  );

export const triggerMeetingFollowup = async ({
  workspace_id,
  meeting_external_id,
  meeting_title,
  scheduled_at,
  company_name,
  company_domain,
  attendees = [],
  force = false,
}: TriggerMeetingPrepParams) =>
  authorizedApiClient.post<MeetingPrepRun>(
    `/workspace/${workspace_id}/meetings/${meeting_external_id}/followup`,
    {
      meeting_title: meeting_title || undefined,
      scheduled_at: scheduled_at || undefined,
      company_name: company_name || undefined,
      company_domain: company_domain || undefined,
      attendees,
      force,
    },
  );

type GetMeetingPrepRunsParams = {
  workspace_id: string;
  meeting_external_id: string;
  limit?: number;
};

export const getMeetingPrepRuns = async ({
  workspace_id,
  meeting_external_id,
  limit = 20,
}: GetMeetingPrepRunsParams) =>
  authorizedApiClient.get<{ meeting_external_id: string; runs: MeetingPrepRun[] }>(
    `/workspace/${workspace_id}/meetings/${meeting_external_id}/prep`,
    {
      params: { limit },
    },
  );

type GetWorkspaceMeetingPrepRunsParams = {
  workspace_id: string;
  status?: "pending" | "running" | "success" | "failed";
  limit?: number;
  offset?: number;
};

export const getWorkspaceMeetingPrepRuns = async ({
  workspace_id,
  status,
  limit = 20,
  offset = 0,
}: GetWorkspaceMeetingPrepRunsParams) =>
  authorizedApiClient.get<{ runs: MeetingPrepRun[] }>(
    `/workspace/${workspace_id}/meeting-prep-runs`,
    {
      params: {
        status,
        limit,
        offset,
      },
    },
  );

